













































import Vue from 'vue'
import { menuLinks } from '@/router/'
import RouteLink from '@/interfaces/app/RouteLink'

export default Vue.extend({
  computed: {
    links(): RouteLink[] {
      return menuLinks
    },
    sidebar: {
      get(): boolean {
        return this.$store.getters['app/sidebar']
      },
      set(value: boolean): void {
        this.$store.commit('app/setSidebar', value)
      },
    },
  },
})
